 /*eslint-disable */
 // selectors
  export const selectBulkStatusesArray = (state) => state.uploadStatus.bulkStatuses

  export const selectBulkUploadStatus = (state) => state.uploadStatus.status

  export const selectBulkUploadError = (state) => state.uploadStatus.error

